import React from "react";
import { Link } from 'gatsby';
import logo from '../assets/images/IJBStreetwearSinceRed.png';
import styled from 'styled-components';
import Instagram from "../components/Instagram";
import SEO from '../components/SEO';

const MainContentStyles = styled.main`
   img {
     width: 100%;
     display: block;
   }

   .main-logo {
     display: block;
     width: 100%;
     margin: 0 auto;
     border-radius: .5rem;
     box-shadow: 0 5px 15px var(--grey);
     margin-top: 5rem;
   }

   .title {
     text-align: center;
     margin-top: 7rem;
     margin-bottom: 7rem; 
     
     p {
       font-size: 2rem;
       font-style: italic;
       text-shadow: 1px 2px 5px rgba(0, 0, 0, 0.3);
       @media (max-width: 650px) {
         font-size: 1.4rem;
       }
     }
   }

   .cta {
      padding: 4rem 0;
      font-size: 3rem;
      text-align: center;
      @media (max-width: 650px) {
          font-size: 2rem;
      }

    a {
      color: var(--white);
      background-color: var(--black);
      display: inline-block;
      border: 1px solid var(--grey);
      padding: .5rem 1.5rem;
      border-radius: .5rem;
      margin-bottom: 2.5rem;
      box-shadow: 0 5px 10px -3px rgba(0,0,0,.25);
      transition: all .3s;

      &:hover {
          box-shadow: 0 10px 20px -6px rgba(0,0,0,.5);
      }

      &:hover > * {
          color: var(--white);
      }
  }  
   }
`;

export default function Home() {
  return (
    <>
      {/* eslint-disable-next-line */}
      <SEO title="Home" />
      <MainContentStyles>
        <img src={logo} alt="I'm just beastin, streetwear since 2016 site banner" className="main-logo" />
        <div className="title">
          <p>I’m Just Beastin’ is the brand for those who beast in all aspects of life, regardless of situation or circumstances, while needing little to no motivation to succeed.</p>
        </div>
        <div className="cta">
          <Link to={'/products'}>see all products</Link>
        </div>
        {/* <Instagram /> */}
      </MainContentStyles>
    </>
  )
}